import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormAgente from "./formulario";

export function AgenteVisualizar() {
  const idagente = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Visualizar Agente" />
        <FormAgente idagente={idagente.id} acao="Visualizar" />
      </div>
    </>
  );
} 